<template>
  <div>
    <v-app-bar
      id="app-bar-customer"
      class="customer-app-bar"
      color="white"
      :density="$vuetify.display.mdAndUp ? 'prominent' : 'comfortable'"
      :height="$vuetify.display.mdAndUp ? undefined : 80"
      flat
    >
      <v-container
        fluid
        class="v-app-bar-content"
      >
        <v-row>
          <!-- Start Logo -->
          <v-col
            cols="8"
            md="2"
          >
            <v-toolbar-title :class="{ 'mt-4': $vuetify.display.mdAndUp }">
              <logo-link to="/contacts" />
            </v-toolbar-title>
          </v-col>
          <!-- End Logo -->
          <!-- Start Menu Items -->
          <v-col
            v-if="$vuetify.display.mdAndUp"
            class="pt-8"
          >
            <div class="links-container">
              <template
                v-for="(item, index) in menuItems"
                :key="item.title"
              >
                <span
                  v-if="index > 0"
                  class="link-gap"
                />
                <router-link
                  :to="item.link"
                  class="w-1 link"
                >
                  <div class="font-weight-black text-black navbar-text customer-navbar-items">
                    {{ item.title }}
                  </div>
                </router-link>
              </template>
            </div>
          </v-col>
          <!-- End Menu Items -->
          <!-- Start User Menu Items -->
          <v-col
            v-if="$vuetify.display.mdAndUp"
            cols="auto"
            class="pt-9"
          >
            <v-btn
              class="ml-2 float-right logout-btn"
              min-width="0"
              variant="outlined"
              data-testid="logout-button"
              @click="onLogout"
            >
              {{ logoutButtonText }}
              <v-icon end>
                mdi-account-arrow-right
              </v-icon>
            </v-btn>
          </v-col>
          <!-- End User Menu Items -->
          <!-- Start Hamburguer Menu Icon -->
          <v-col
            v-if="$vuetify.display.smAndDown"
            cols="4"
          >
            <v-app-bar-nav-icon
              variant="outlined"
              class="float-right"
              color="primary"
              @click.stop="menuDrawer = !menuDrawer"
            />
          </v-col>
          <!-- End Hamburguer Menu Icon -->
        </v-row>
      </v-container>
    </v-app-bar>
    <!-- Start Navigation Menu Drawer -->
    <v-navigation-drawer
      v-if="$vuetify.display.smAndDown"
      v-model="menuDrawer"
      location="bottom"
      temporary
    >
      <v-list
        nav
        density="compact"
        active-class="text-primary"
      >
          <v-list-item
            v-for="item in menuItems"
            :key="item.title"
            :to="item.link"
          >
            <v-list-item-title class="text-button font-weight-black">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            class="primary-list-item-outlined"
            @click="onLogout"
          >
            <v-list-item-title class="text-button">
              {{ logoutButtonText }}
            </v-list-item-title>
          </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- End Navigation Menu Drawer -->
  </div>
</template>

<script>
  import LogoLink from '../components/LogoLink.vue'
  import router from '@/router'

  export default {
    components: {
      LogoLink,
    },
    data () {
      return {
        menuDrawer: false,
        router,
      }
    },
    computed: {
      logoutButtonText () {
        return this.$t('logout')
      },
      menuItems () {
        return [
          { title: this.$t('layouts.core.appbarcustomer.contacts'), link: {name: 'Contacts'} },
          { title: this.$t('layouts.core.appbarcustomer.confidants'), link: {name: 'Confidants'} },
          { title: this.$t('layouts.core.appbarcustomer.templates'), link: {name: 'Templates'} },
          { title: this.$t('layouts.core.appbarcustomer.selfProtection'), link: {name: 'SelfProtection'} },
          { title: this.$t('layouts.core.appbarcustomer.settings'), link: {name: 'AccountSettings'} },
        ]
      },
    },
    methods: {
      onLogout () {
        console.log('[AUTH] User logout:', {
          userType: 'customer',
          name: sessionStorage.name,
          timestamp: new Date().toISOString()
        })
        
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('isCustomer')
        sessionStorage.removeItem('isAdmin')
        sessionStorage.removeItem('name')
        this.router.push('/login')
      },
    },
  }
</script>

<style>
  #app-bar-customer {
    z-index: 10 !important;
  }
  
  .top{
    margin-top: 128px !important;
  }
  .pe-pro-seal {
    display: none;
  }
  .links-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
  }

  /* Wide translated labels used to wrap the logout column onto a second line that
     the fixed-height bar clips. The row stays on one line and the space between the
     links sits in shrinkable spacers, resting at the 32px the two `mx-4` margins
     used to give, so locales with room to spare render unchanged.
     Scoped on a class because `#app-bar-customer` is also the confidant bar's id. */
  .customer-app-bar .v-row {
    flex-wrap: nowrap;
  }

  .customer-app-bar .links-container .link {
    flex: 0 0 auto;
  }

  .customer-app-bar .links-container .link-gap {
    flex: 0 1 32px;
  }

  /* Below md the bar is 72px but the uncapped logo renders 78px and carried a further
     4px nudge, so it spilled onto the banner underneath, while the hamburger sat 14px
     above the bar's centre. Centre the row instead of hand-placing each item, and keep
     the logo inside the bar. 959.98px is Vuetify's own smAndDown edge, so the desktop
     bar at exactly 960px is untouched. */
  @media (max-width: 959.98px) {
    .customer-app-bar .v-row {
      align-items: center;
    }

    .customer-app-bar .v-row > .v-col {
      display: flex;
      align-items: center;
    }

    .customer-app-bar .v-row > .v-col:last-child {
      justify-content: flex-end;
    }

    .customer-app-bar .v-toolbar-title {
      width: 100%;
    }

    .customer-app-bar .logo {
      max-height: 64px;
      margin-top: 0;
    }

    .customer-app-bar .v-app-bar-nav-icon {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .navbar-text {
    white-space: nowrap;
    font-size: 0.85rem !important;
  }
  #app-bar-customer .v-btn {
    font-size: 0.85rem !important;
  }

  .link:hover .navbar-text{
    color: #329c36 !important;
  }

  .router-link-active .navbar-text{
    color: #329c36 !important;
  }

  @media only screen and (min-height: 1150px ) {
    .v-application__wrap {
      min-height: 100vh !important;
    }
  }
</style>
